<template>
  <div id="meeting-camera-setting" class="meeting-camera-setting">
    <!-- オンラインレイアウト -->
    <div id="video-area" class="mb-0" v-if="getIsOnlineMeeting">
      <BOverlay :show="overlayShow" rounded="sm" class="row video-control">
        <button type="button" class="btn ps-0 pe-0 col text-white bg-dark rounded-0" @click="microphoneMute" style="font-size: 1.2rem;">
          <i class="bi bi-mic-fill" v-show="!getIsMicrophoneMute"></i>
          <i class="bi bi-mic-mute-fill" v-show="getIsMicrophoneMute"></i>
        </button>
        <button type="button" id="volume-button" class="btn ps-0 pe-0 col text-white bg-dark rounded-0" @click="volumeShow" style="font-size: 1.2rem;">
          <i class="bi bi-volume-up-fill" v-show="getSpeakerVolume > 0.5"></i>
          <i class="bi bi-volume-down-fill" v-show="getSpeakerVolume <= 0.5 && getSpeakerVolume > 0.2"></i>
          <i class="bi bi-volume-off-fill" v-show="getSpeakerVolume <= 0.2 && getSpeakerVolume > 0"></i>
          <i class="bi bi-volume-mute-fill" v-show="getSpeakerVolume === 0"></i>
        </button>
        <button type="button" class="btn ps-0 pe-0 col text-white bg-dark rounded-0" @click="stopVideo" style="font-size: 1.2rem;">
          <i class="bi" :class="getIsCameraStop ? 'bi-camera-video-off-fill' : 'bi-camera-video-fill'"></i>
        </button>
        <button type="button" class="btn ps-0 pe-0 col text-white bg-dark rounded-0" @click="stopVirtualBackground" style="font-size: 1.2rem;">
          <i class="bi" :class="getIsVirtualBackgroundStop ? 'bi-person-fill' : 'bi-person-square'"></i>
        </button>
        <button type="button" class="btn ps-0 pe-0 col text-white bg-danger rounded-0" @click="confirmFinishMeeting" style="font-size: 1.2rem;">
          <i class="bi bi-telephone-x-fill"></i>
        </button>
      </BOverlay>

      <BOverlay :show="overlayShow" rounded="sm" class="row video-cover">
        <div class="user-video-hide p-0" id="myself"></div>
        <div class="user-video-hide p-0" id="yourself"></div>
        <div class="user-video-hide-guest p-0" id="guest1"></div>
        <div class="user-video-hide-guest p-0" id="guest2"></div>
        <div class="user-video-hide-guest p-0" id="guest3"></div>
      </BOverlay>

      <div class="row justify-content-center">
        <input
          type="range"
          class="volume-range"
          style="width: 15%; top: 120px"
          orient="vertical"
          v-show="isVolumeRange"
          ref="volumeRenge"
          @input="volumeChange"
        >
      </div>
      <audio style="display:none" ref="meetingAudio"></audio>
    </div>

    <!-- オフラインレイアウト -->
    <div id="video-area" class="mb-0 d-none" v-else>
      <BOverlay :show="overlayShow" rounded="sm" class="row video-control">
        <button type="button" class="btn ps-0 col text-white bg-dark rounded-0 disabled">
          <i class="bi bi-mic-fill"></i>
        </button>
        <button type="button" class="btn ps-0 col text-white bg-dark rounded-0 disabled">
          <i class="bi bi-volume-up-fill"></i>
        </button>
        <button type="button" class="btn ps-0 col text-white bg-dark rounded-0 disabled">
          <i class="bi bi-camera-video-fill"></i>
        </button>
        <button type="button" class="btn ps-0 col text-white bg-dark rounded-0 disabled">
          <i class="bi bi-person-square"></i>
        </button>
        <button type="button" class="btn ps-0 col text-white bg-danger rounded-0" @click="hangUp">
          <i class="bi bi-telephone-x-fill"></i>
        </button>
      </BOverlay>
      <BOverlay :show="overlayShow" rounded="sm" class="row video-cover">
        <div class="user-video-hide" id="myself"></div>
        <div class="user-video-hide" id="yourself"></div>
        <audio style="display:none" ref="meetingAudio"></audio>
      </BOverlay>
    </div>
    <div
      id="selected-style-images"
      class="row base-color border align-content-start"
      :class="{'ms-0 h-500 w-100 p-2': windowWidth >= 576}"
      v-show="isCustomerMeetingStyleImage"
    ></div>
    <CommonModal ref="commonModal" @confirmOk="hangUp" />
  </div>
</template>
<style>
.user-video-hide {
  position: relative;
  background-color: #000;
  height: 170px;
}

.user-video-hide::after {
  position: absolute;
  content: "..no display";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: #fff;
}

.user-video-hide-guest {
  margin-top: 3px;
  position: relative;
  background-color: #000;
  height: 83px;
  width: 50%;
  border: 1px solid #EEF0F1
}

.user-video-hide-guest::after {
  font-size: small;
  position: absolute;
  content: "..no display";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: #fff;
}

.user-video-guest {
  margin-top: 3px;
  width: 50%;
  height: 83px;
  position: relative;
}

.video-element-guest {
  width: 100%;
  height: 100%;
  position: absolute;
}
.share-content-hide {
  background-color: #000;
  width: 100%;
  height: 500px;
}

.volume-range {
  position: absolute;
  top: 50px;
  z-index: 20;
  background-color: #fff;
}

.video-control {
  position: relative;
}
</style>

<script>
import {
  ConsoleLogger,
  DefaultDeviceController,
  DefaultMeetingSession,
  LogLevel,
  MeetingSessionConfiguration,
  BackgroundReplacementVideoFrameProcessor,
  DefaultVideoTransformDevice
} from 'amazon-chime-sdk-js'
import MeetingJoinModel from '@/models/MeetingJoinModel'
import ChimeLogModel from '@/models/ChimeLogModel'
import mstore from '@/store/meeting-store'
import fstore from '@/store/florist-store'
import cstore from '@/store/customer-store'
import CommonModal from '@/components/CommonModal'
import logoff from '@/mixins/logoff'
import MeetingInfoGetModel from '@/models/MeetingInfoGetModel'
import { markRaw } from 'vue'

const isDebug = process.env.NODE_ENV !== 'production'

const isOnlineMeeting = () => localStorage.getItem('isOnlineMeeting') === 'true'
export default {
  name: 'MeetingCameraSetting',
  components: {
    CommonModal
  },
  props: {
    type: { type: Number, required: true }
  },
  data () {
    return {
      deviceController: null,
      logger: null,
      isVolumeRange: false,
      windowWidth: 0,
      loginStatus: '',
      overlayShow: false,
      onDocClick: null
    }
  },
  computed: {
    isCustomerMeetingStyleImage () {
      return (
        this.type === this.consts.meetingType.customerStyleImageProposal ||
        this.type === this.consts.meetingType.floristStyleImageProposal
      )
    },
    getIsMicrophoneMute () {
      return mstore.getters.isMicrophoneMute
    },
    getSpeakerVolume () {
      return mstore.getters.speakerVolume
    },
    getIsCameraStop () {
      return mstore.getters.isCameraStop
    },
    getIsVirtualBackgroundStop () {
      return mstore.getters.isVirtualBackgroundStop
    },
    getIsOnlineMeeting () {
      return isOnlineMeeting()
    }
  },
  methods: {
    // ビデオ通話スタート
    start: async function () {
      if (mstore.getters.meetingSession) {
        return false
      }
      try {
        this.overlayShow = true
        // セッションストレージにmeeting情報がない場合
        if (!sessionStorage.meeting || !sessionStorage.attendee) {
          const joinResult = await MeetingJoinModel.apiSetStore(this.$bvModal, () => {
            // ミーティング参加失敗時
            if (this.$route.path.split('/')[1] === 'customer') {
              alert('ミーティング情報が取得できませんでした。\nもう一度ログインしてください。')
              this.$router.push('/customer/login')
            }
            if (this.$route.path.split('/')[1] === 'florist' && this.loginStatus?.prodInst !== '1') {
              this.$router.push('/florist/meeting/error')
            }
          })
          if (joinResult) {
            // ミーティング参加成功時
            sessionStorage.meeting = JSON.stringify(joinResult.meeting)
            sessionStorage.attendee = JSON.stringify(joinResult.attendee)
            // Vue Router 4では this.$router.go({path, force:true}) が使えないため、確実に再構築
            window.location.reload()
            return
          } else {
            this.overlayShow = false
            return false
          }
        }

        const meeting = JSON.parse(sessionStorage.meeting)
        const attendee = JSON.parse(sessionStorage.attendee)
        const configuration = new MeetingSessionConfiguration(meeting, attendee)
        const meetingSession = await markRaw(new DefaultMeetingSession(configuration, this.logger, this.deviceController))

        // MeetingSessionのログ取得用observerを設定
        meetingSession.eventController.addObserver({
          eventDidReceive: (name, attributes) => {
            const { meetingHistory, ...otherAttributes } = attributes
            // ログにフローリストかカスタマーなのかの情報を埋め込む
            if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
              otherAttributes['user'] = 'florist'
              // kintoneのログインユーザー名も格納
              otherAttributes['userName'] = this.loginStatus.userName
            }
            if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
              otherAttributes.user = 'customer'
            }
            switch (name) {
              case 'audioInputFailed':
              case 'videoInputFailed':
              case 'meetingStartFailed':
              case 'meetingFailed':
                this.pushMeetingEvents({
                  name,
                  attributes: {
                    ...otherAttributes,
                    meetingHistory: meetingHistory.filter(({ timestampMs }) => {
                      return Date.now() - timestampMs < 5 * 60 * 1000
                    })
                  }
                })
                break
              default:
                this.pushMeetingEvents({
                  name,
                  attributes: otherAttributes
                })
                if (name === 'meetingEnded') {
                  if (sessionStorage.noDisplayMessageFlag !== 'true') {
                    this.$refs.commonModal.msgBoxOk('接続が切れました。右上のリロードを選択してください。それでも復旧出来ない場合は担当者からの連絡をお待ちください。または担当者へご連絡ください。')
                  } else {
                    sessionStorage.removeItem('noDisplayMessageFlag')
                  }
                }
                break
            }
          }
        })
        meetingSession.audioVideo.addObserver({
          audioVideoDidStop: () => {
            // 打合せ終了時にMeetingSessionのログをCloudWatchに送信
            setTimeout(this.sendMeetingEventLogs.bind(this, null), 0)
          }
        })

        const audioInputs = await meetingSession.audioVideo.listAudioInputDevices()
        if (audioInputs[0].deviceId) {
          await meetingSession.audioVideo.startAudioInput(audioInputs[0].deviceId)
        } else {
          await meetingSession.audioVideo.startAudioInput(null)
        }
        meetingSession.audioVideo.chooseVideoInputQuality(640, 360, 15)
        let observer = {}

        if (isOnlineMeeting()) {
          const videoInputs = await meetingSession.audioVideo.listVideoInputDevices()
          // 背景設定（重複を関数化）
          const applyBackground = async (url) => {
            const processors = []
            if (await BackgroundReplacementVideoFrameProcessor.isSupported()) {
              const image = await fetch(url)
              const imageBlob = await image.blob()
              const options = { imageBlob }
              const replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(null, options)
              processors.push(replacementProcessor)
            }
            if (videoInputs[0].deviceId) {
              const transformDevice = new DefaultVideoTransformDevice(this.logger, videoInputs[0].deviceId, processors)
              await meetingSession.audioVideo.startVideoInput(transformDevice)
            }
          }
          // フローリスト側背景画像設定
          if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
            await applyBackground(this.config.floristMeetingVirtualBackgroundImageURL)
          }
          // お客様側背景画像設定
          if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
            await applyBackground(this.config.customerMeetingVirtualBackgroundImageURL)
          }

          observer = {
            videoTileDidUpdate: (tileState) => {
              if (isDebug) {
                console.log('VIDEO TILE DID UPDATE')
              }
              if (!tileState.boundAttendeeId) {
                return false
              }
              this.updateTiles(meetingSession)
            },
            videoTileWasRemoved: (tileId) => {
              let myselfElm = document.getElementById('myself')
              let yourselfElm = document.getElementById('yourself')
              let guest1selfElm = document.getElementById('guest1')
              let guest2selfElm = document.getElementById('guest2')
              let guest3selfElm = document.getElementById('guest3')
              let myselfTileId = Number(sessionStorage.getItem('myselfTileId'))
              let yourselfTileId = Number(sessionStorage.getItem('yourselfTileId'))
              let guest1selfTileId = Number(sessionStorage.getItem('guest1TileId'))
              let guest2selfTileId = Number(sessionStorage.getItem('guest2TileId'))
              let guest3selfTileId = Number(sessionStorage.getItem('guest3TileId'))
              if (tileId === myselfTileId && myselfElm) {
                myselfElm.classList.add('user-video-hide')
                sessionStorage.setItem('hideMySelfVideo', 'true')
              }
              if (tileId === yourselfTileId && yourselfElm) {
                yourselfElm.classList.add('user-video-hide')
                sessionStorage.setItem('hideYourSelfVideo', 'true')
              }
              if (tileId === guest1selfTileId && guest1selfElm) {
                guest1selfElm.classList.add('user-video-hide-guest')
                sessionStorage.setItem('hideGuest1SelfVideo', 'true')
              }
              if (tileId === guest2selfTileId && guest2selfElm) {
                guest2selfElm.classList.add('user-video-hide-guest')
                sessionStorage.setItem('hideGuest2SelfVideo', 'true')
              }
              if (tileId === guest3selfTileId && guest3selfElm) {
                guest3selfElm.classList.add('user-video-hide-guest')
                sessionStorage.setItem('hideGuest3SelfVideo', 'true')
              }
            },
            contentShareDidStart: (tileState) => {
              if (isDebug) {
                console.log('Screen share started')
              }
            },
            contentShareDidStop: () => {
              if (isDebug) {
                console.log('Screen share stopped')
              }
            }
          }
        }

        meetingSession.audioVideo.addObserver(observer)

        meetingSession.audioVideo.bindAudioElement(this.$refs.meetingAudio)
        meetingSession.audioVideo.start()

        // 開始時、マイクはミュート
        meetingSession.audioVideo.realtimeMuteLocalAudio()
        mstore.commit('setIsMicrophoneMute', true)

        mstore.commit('setMeetingSession', meetingSession)

        meetingSession.audioVideo.realtimeSubscribeToReceiveDataMessage('links-meeting-topic', (msg) => {
          const textDecoder = new TextDecoder()
          const data = JSON.parse(textDecoder.decode(msg.data))
          if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
            fstore.commit('setSignalingReceiveData', data)
          }
          if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
            if (data?.event === 'click' && data?.id === 'hangUp') {
              // お客様をhangUpさせる処理が届いたときは、ストレージに格納せず処理する
              this.hangUp()
            } else {
              cstore.commit('setSignalingReceiveData', data)
            }
          }
        })

        meetingSession.audioVideo.realtimeSubscribeToAttendeeIdPresence((presentAttendeeId, present) => {
          if (isDebug) {
            console.log(`Attendee ID: ${presentAttendeeId} Present: ${present}`)
          }
          // ミーティング相手との疎通が有効になったかのフラグをストアに保存
          if (presentAttendeeId !== attendee.AttendeeId) {
            mstore.commit('setIsTargetAtendeeActive', present)
          }
        })
        setTimeout(() => {
          this.overlayShow = false
        }, 1000)
      } catch (err) {
        console.log(err)
        this.overlayShow = false
      }
    },
    // ビデオステータス変更
    updateTiles: async function (meetingSession) {
      const meetingInfoStore = await MeetingInfoGetModel.apiSetStore(this.$bvModal, () => {})
      const tiles = await meetingSession.audioVideo.getAllVideoTiles()
      const floristAttendeeId = meetingInfoStore.meetingURL['floristAttendeeId']
      const customerAttendeeId = meetingInfoStore.meetingURL['customerAttendeeId']
      let i = 1
      tiles.forEach(tile => {
        let tileId = tile.tileState.tileId
        let isMyselfTile = tile.tileState.localTile
        let tileAttendeeId = tile.tileState.boundAttendeeId
        var videoElement
        if (isMyselfTile) {
          // 自分がメインかつ現在のメインの参加者IDと自分の参加者IDが一致しなかった場合、他のメインに割り込まれたとみなし、customerTypeをguestに変更し操作権も無くす
          if (((this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) && sessionStorage.customerType === this.consts.customerType.main) && tileAttendeeId !== customerAttendeeId) {
            sessionStorage.customerType = this.consts.customerType.guest
            cstore.commit('setIsOperationPossible', false)
            window.location.reload()
          }
          // 自分がゲストカスタマーの場合はguest1の位置に自分の映像を出力する
          if (sessionStorage.customerType === this.consts.customerType.guest) {
            videoElement = document.getElementById('video-guest1')
          } else {
            videoElement = document.getElementById('video-myself')
          }
        } else {
          // 自分がフローリストの場合
          if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
            if (tileAttendeeId === customerAttendeeId) {
              videoElement = document.getElementById('video-otherwise')
            } else {
              let videoGuestName = 'video-guest' + String(i)
              videoElement = document.getElementById(videoGuestName)
            }
          }
          // 自分がメインカスタマーの場合
          if ((this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) && sessionStorage.customerType === this.consts.customerType.main) {
            if (tileAttendeeId === floristAttendeeId) {
              videoElement = document.getElementById('video-otherwise')
            } else {
              let videoGuestName = 'video-guest' + String(i)
              videoElement = document.getElementById(videoGuestName)
            }
          }
          // 自分がゲストカスタマーの場合
          if (sessionStorage.customerType === this.consts.customerType.guest) {
            if (tileAttendeeId === floristAttendeeId) {
              videoElement = document.getElementById('video-otherwise')
            } else if (tileAttendeeId === customerAttendeeId) {
              videoElement = document.getElementById('video-myself')
            } else {
              let videoGuestName = 'video-guest' + String(i)
              videoElement = document.getElementById(videoGuestName)
            }
          }
        }

        // 新規作成
        if (!videoElement) {
          if (isMyselfTile) {
            // 自分がゲストカスタマーの場合はguest1の位置に自分の映像を出力する
            if (sessionStorage.customerType === this.consts.customerType.guest) {
              videoElement = this.addVideoView('video-guest1', 'guest1', 'setGuest1selfVideo', 'user-video-hide-guest', true)
              i += 1
            } else {
              videoElement = this.addVideoView('video-myself', 'myself', 'setMyselfVideo')
            }
          } else {
            // 自分がフローリストの場合
            if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
              if (tileAttendeeId === customerAttendeeId) {
                videoElement = this.addVideoView('video-otherwise', 'yourself', 'setYourselfVideo')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestName = 'video-guest' + String(i)
                  let videoGuestId = 'guest' + String(i)
                  let commitName = 'setGuest' + String(i) + 'selfVideo'
                  videoElement = this.addVideoView(videoGuestName, videoGuestId, commitName, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
            // 自分がメインカスタマーの場合
            if ((this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) && sessionStorage.customerType === this.consts.customerType.main) {
              if (tileAttendeeId === floristAttendeeId) {
                videoElement = this.addVideoView('video-otherwise', 'yourself', 'setYourselfVideo')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestName = 'video-guest' + String(i)
                  let videoGuestId = 'guest' + String(i)
                  let commitName = 'setGuest' + String(i) + 'selfVideo'
                  videoElement = this.addVideoView(videoGuestName, videoGuestId, commitName, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
            // 自分がゲストカスタマーの場合
            if (sessionStorage.customerType === this.consts.customerType.guest) {
              if (tileAttendeeId === floristAttendeeId) {
                videoElement = this.addVideoView('video-otherwise', 'yourself', 'setYourselfVideo')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else if (tileAttendeeId === customerAttendeeId) {
                videoElement = this.addVideoView('video-myself', 'myself', 'setMyselfVideo')
                sessionStorage.setItem('myselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestName = 'video-guest' + String(i)
                  let videoGuestId = 'guest' + String(i)
                  let commitName = 'setGuest' + String(i) + 'selfVideo'
                  videoElement = this.addVideoView(videoGuestName, videoGuestId, commitName, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
          }
        // 更新
        } else {
          // 自分
          if (isMyselfTile) {
          // 自分がゲストカスタマーの場合はguest1の位置に自分の映像を出力する
            let parentElm
            if (sessionStorage.customerType === this.consts.customerType.guest) {
              parentElm = document.getElementById('guest1')
              this.changeVideoView(parentElm, tile.tileState, 'guest1', 'user-video-hide-guest', true)
              i += 1
            } else {
              parentElm = document.getElementById('myself')
              this.changeVideoView(parentElm, tile.tileState, 'myself')
            }
          // 相手
          } else {
            // 自分がフローリストの場合
            if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
              if (tileAttendeeId === customerAttendeeId) {
                let parentElm = document.getElementById('yourself')
                this.changeVideoView(parentElm, tile.tileState, 'yourself')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestId = 'guest' + String(i)
                  let parentElm = document.getElementById(videoGuestId)
                  this.changeVideoView(parentElm, tile.tileState, videoGuestId, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
            // 自分がメインカスタマーの場合
            if ((this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) && sessionStorage.customerType === this.consts.customerType.main) {
              if (tileAttendeeId === floristAttendeeId) {
                let parentElm = document.getElementById('yourself')
                this.changeVideoView(parentElm, tile.tileState, 'yourself')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestId = 'guest' + String(i)
                  let parentElm = document.getElementById(videoGuestId)
                  this.changeVideoView(parentElm, tile.tileState, videoGuestId, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
            // 自分がゲストカスタマーの場合
            if (sessionStorage.customerType === this.consts.customerType.guest) {
              if (tileAttendeeId === floristAttendeeId) {
                let parentElm = document.getElementById('yourself')
                this.changeVideoView(parentElm, tile.tileState, 'yourself')
                sessionStorage.setItem('yourselfTileId', tileId)
              } else if (tileAttendeeId === customerAttendeeId) {
                let parentElm = document.getElementById('myself')
                this.changeVideoView(parentElm, tile.tileState, 'myself')
                sessionStorage.setItem('myselfTileId', tileId)
              } else {
                if (i <= 3) {
                  let videoGuestId = 'guest' + String(i)
                  let parentElm = document.getElementById(videoGuestId)
                  this.changeVideoView(parentElm, tile.tileState, videoGuestId, 'user-video-hide-guest', true)
                  sessionStorage.setItem(videoGuestId + 'TileId', tileId)
                  i += 1
                }
              }
            }
          }
        }

        if (videoElement) {
          meetingSession.audioVideo.bindVideoElement(tileId, videoElement)
        }
      })
    },
    // ビデオオフ
    stopVideo: async function () {
      let meetingSession = mstore.getters.meetingSession
      if (this.getIsCameraStop && meetingSession !== null) {
        if (this.getIsVirtualBackgroundStop === false) {
          // 自分がゲストの場合はguest1の位置をオンオフの対象にする
          if (sessionStorage.customerType === this.consts.customerType.guest) {
            let myselfVideo = document.getElementById('guest1')
            myselfVideo.classList.remove('user-video-hide-guest')
          } else {
            let myselfVideo = document.getElementById('myself')
            myselfVideo.classList.remove('user-video-hide')
          }
          const videoInputs = await meetingSession.audioVideo.listVideoInputDevices()
          // フローリスト側背景画像設定
          if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
            const processors = []
            if (await BackgroundReplacementVideoFrameProcessor.isSupported()) {
              const image = await fetch(this.config.floristMeetingVirtualBackgroundImageURL)
              const imageBlob = await image.blob()
              const options = { imageBlob }
              const replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(null, options)
              processors.push(replacementProcessor)
            }
            let transformDevice = new DefaultVideoTransformDevice(this.logger, videoInputs[0].deviceId, processors)
            await meetingSession.audioVideo.startVideoInput(transformDevice)
          }
          // お客様側背景画像設定
          if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
            const processors = []
            if (await BackgroundReplacementVideoFrameProcessor.isSupported()) {
              const image = await fetch(this.config.customerMeetingVirtualBackgroundImageURL)
              const imageBlob = await image.blob()
              const options = { imageBlob }
              const replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(null, options)
              processors.push(replacementProcessor)
            }
            let transformDevice = new DefaultVideoTransformDevice(this.logger, videoInputs[0].deviceId, processors)
            await meetingSession.audioVideo.startVideoInput(transformDevice)
          }
        } else {
          const videoInputs = await meetingSession.audioVideo.listVideoInputDevices()
          await meetingSession.audioVideo.startVideoInput(videoInputs[0].deviceId)
        }
        meetingSession.audioVideo.startLocalVideoTile()
        mstore.commit('setIsCameraStop', false)
      } else {
        if (meetingSession !== null) {
          if (sessionStorage.customerType === this.consts.customerType.guest) {
            let myselfVideo = document.getElementById('guest1')
            myselfVideo.classList.add('user-video-hide-guest')
          } else {
            let myselfVideo = document.getElementById('myself')
            myselfVideo.classList.add('user-video-hide')
          }
          meetingSession.audioVideo.stopLocalVideoTile()
        }
        mstore.commit('setIsCameraStop', true)
      }
    },
    // バーチャル背景オンオフ
    stopVirtualBackground: async function () {
      let meetingSession = mstore.getters.meetingSession
      // カメラオフ状態の場合はバーチャル背景オンオフフラグのみ切り替える
      if (this.getIsCameraStop) {
        mstore.commit('setIsVirtualBackgroundStop', !this.getIsVirtualBackgroundStop)
        return
      }
      if (this.getIsVirtualBackgroundStop) {
        if (meetingSession !== null) {
          // 自分がゲストの場合はguest1の位置をオンオフの対象にする
          if (sessionStorage.customerType === this.consts.customerType.guest) {
            let myselfVideo = document.getElementById('guest1')
            myselfVideo.classList.remove('user-video-hide-guest')
          } else {
            let myselfVideo = document.getElementById('myself')
            myselfVideo.classList.remove('user-video-hide')
          }
          const videoInputs = await meetingSession.audioVideo.listVideoInputDevices()
          // フローリスト側背景画像設定
          if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
            const processors = []
            if (await BackgroundReplacementVideoFrameProcessor.isSupported()) {
              const image = await fetch(this.config.floristMeetingVirtualBackgroundImageURL)
              const imageBlob = await image.blob()
              const options = { imageBlob }
              const replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(null, options)
              processors.push(replacementProcessor)
            }
            let transformDevice = new DefaultVideoTransformDevice(this.logger, videoInputs[0].deviceId, processors)
            await meetingSession.audioVideo.startVideoInput(transformDevice)
          }
          // お客様側背景画像設定
          if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
            const processors = []
            if (await BackgroundReplacementVideoFrameProcessor.isSupported()) {
              const image = await fetch(this.config.customerMeetingVirtualBackgroundImageURL)
              const imageBlob = await image.blob()
              const options = { imageBlob }
              const replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(null, options)
              processors.push(replacementProcessor)
            }
            let transformDevice = new DefaultVideoTransformDevice(this.logger, videoInputs[0].deviceId, processors)
            await meetingSession.audioVideo.startVideoInput(transformDevice)
          }
          meetingSession.audioVideo.startLocalVideoTile()
        }
        mstore.commit('setIsVirtualBackgroundStop', false)
      } else {
        if (meetingSession !== null) {
          const videoInputs = await meetingSession.audioVideo.listVideoInputDevices()
          await meetingSession.audioVideo.startVideoInput(videoInputs[0].deviceId)
        }
        mstore.commit('setIsVirtualBackgroundStop', true)
      }
    },
    // 通話終了
    hangUp: async function () {
      sessionStorage.setItem('noDisplayMessageFlag', 'true')
      if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
        // お客様側もhangUpさせるように指示を出す
        await mstore.getters.meetingSession.audioVideo.realtimeSendDataMessage('links-meeting-topic', JSON.stringify({ event: 'click', id: 'hangUp' }))
      } else {
        localStorage.removeItem('tabInfo')
      }
      let result = await logoff.logoff_kyoutu()
      if (result) {
        sessionStorage.removeItem('meeting')
        sessionStorage.removeItem('attendee')
        sessionStorage.removeItem('customerType')
        sessionStorage.removeItem('myselfTileId')
        sessionStorage.removeItem('yourselfTileId')
        sessionStorage.removeItem('guest1TileId')
        sessionStorage.removeItem('guest2TileId')
        sessionStorage.removeItem('guest3TileId')
        sessionStorage.removeItem('hideMySelfVideo')
        sessionStorage.removeItem('hideYourSelfVideo')
        sessionStorage.removeItem('hideGuest1SelfVideo')
        sessionStorage.removeItem('hideGuest2SelfVideo')
        sessionStorage.removeItem('hideGuest3SelfVideo')
      }

      if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
        this.$router.push('/customer/login')
      } else if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
        return false
      } else {
        return false
      }

      // sessionStorageの最終遷移ページ・操作権限削除
      sessionStorage.removeItem('lastRoutePath')
      sessionStorage.removeItem('floristIsOperationPossible')
      sessionStorage.removeItem('customerIsOperationPossible')
    },
    // マイクミュート
    microphoneMute () {
      let meetingSession = mstore.getters.meetingSession
      if (this.getIsMicrophoneMute) {
        if (meetingSession !== null) {
          meetingSession.audioVideo.realtimeUnmuteLocalAudio()
        }
        mstore.commit('setIsMicrophoneMute', false)
      } else {
        if (meetingSession !== null) {
          meetingSession.audioVideo.realtimeMuteLocalAudio()
        }
        mstore.commit('setIsMicrophoneMute', true)
      }
    },
    // ボリューム表示
    volumeShow () {
      this.isVolumeRange = !this.isVolumeRange
    },
    // ボリューム変更
    volumeChange () {
      if (isOnlineMeeting()) {
        let volume = this.$refs.volumeRenge.value === 0 ? 0 : this.$refs.volumeRenge.value / 100
        this.$refs.meetingAudio.volume = volume
        mstore.commit('setSpeakerVolume', volume)
      }
    },
    // ビデオエレメント作成
    addVideoView (id, parentId, storeKey, hideClassName = 'user-video-hide', smallDisplayFlag = false) {
      let videoElement = document.createElement('video')
      videoElement.id = id
      if (smallDisplayFlag) {
        videoElement.classList.add('video-element-guest')
      } else {
        videoElement.classList.add('w-100')
      }
      let parentElm = document.getElementById(parentId)
      if (parentElm) {
        parentElm.classList.remove(hideClassName)
        if (smallDisplayFlag) {
          parentElm.classList.add('user-video-guest')
        }
        parentElm.append(videoElement)
      }
      mstore.commit(storeKey, videoElement)
      if (parentId === 'myself') {
        sessionStorage.setItem('hideMySelfVideo', 'false')
      } else if (parentId === 'yourself') {
        sessionStorage.setItem('hideYourSelfVideo', 'false')
      } else if (parentId === 'guest1') {
        sessionStorage.setItem('hideGuest1SelfVideo', 'false')
      } else if (parentId === 'guest2') {
        sessionStorage.setItem('hideGuest2SelfVideo', 'false')
      } else if (parentId === 'guest3') {
        sessionStorage.setItem('hideGuest3SelfVideo', 'false')
      }
      return videoElement
    },
    changeVideoView (parentElm, tileState, displayPosition, targetClass = 'user-video-hide', smallDisplayFlag = false) {
      if (!parentElm) return
      // ビデオ開始
      if (tileState.active) {
        parentElm.classList.remove(targetClass)
        if (smallDisplayFlag) {
          parentElm.classList.add('user-video-guest')
        }
        if (displayPosition === 'myself' && sessionStorage.hideMySelfVideo === 'true') {
          sessionStorage.setItem('hideMySelfVideo', 'false')
        } else if (displayPosition === 'yourself' && sessionStorage.hideYourSelfVideo === 'true') {
          sessionStorage.setItem('hideYourSelfVideo', 'false')
        } else if (displayPosition === 'guest1' && sessionStorage.hideGuest1SelfVideo === 'true') {
          sessionStorage.setItem('hideGuest1SelfVideo', 'false')
        } else if (displayPosition === 'guest2' && sessionStorage.hideGuest2SelfVideo === 'true') {
          sessionStorage.setItem('hideGuest2SelfVideo', 'false')
        } else if (displayPosition === 'guest3' && sessionStorage.hideGuest3SelfVideo === 'true') {
          sessionStorage.setItem('hideGuest3SelfVideo', 'false')
        }
      // ビデオ停止
      } else {
        parentElm.classList.add(targetClass)
        if (displayPosition === 'myself' && sessionStorage.hideMySelfVideo === 'false') {
          sessionStorage.setItem('hideMySelfVideo', 'true')
        } else if (displayPosition === 'yourself' && sessionStorage.hideYourSelfVideo === 'false') {
          sessionStorage.setItem('hideYourSelfVideo', 'true')
        } else if (displayPosition === 'guest1' && sessionStorage.hideGuest1SelfVideo === 'false') {
          sessionStorage.setItem('hideGuest1SelfVideo', 'true')
        } else if (displayPosition === 'guest2' && sessionStorage.hideGuest2SelfVideo === 'false') {
          sessionStorage.setItem('hideGuest2SelfVideo', 'true')
        } else if (displayPosition === 'guest3' && sessionStorage.hideGuest3SelfVideo === 'false') {
          sessionStorage.setItem('hideGuest3SelfVideo', 'true')
        }
      }
    },
    calculateWindowWidth () {
      const parentElem = document.getElementById('meeting-camera-setting')
      const selectedArea = document.getElementById('selected-style-images')
      const videoArea = document.getElementById('video-area')
      const contentArea = document.getElementById('content-area')
      const footer = document.getElementById('footer')

      this.windowWidth = window.innerWidth

      // 要素が無い場合は何もしない（ルート/画面によっては存在しないことがあるため）
      if (!parentElem || !selectedArea || !videoArea) return

      if (window.innerWidth < 576) {
        if (isOnlineMeeting()) {
          if (contentArea) contentArea.style.marginBottom = videoArea.clientHeight + 50 + 'px'
        } else {
          if (videoArea && footer) videoArea.style.marginBottom = footer.clientHeight + 'px'
          if (contentArea && footer) contentArea.style.marginBottom = videoArea.clientHeight + footer.clientHeight + 50 + 'px'
        }
        parentElem.insertBefore(selectedArea, videoArea)
      } else {
        if (contentArea) contentArea.style.marginBottom = '0px'
        parentElem.insertBefore(selectedArea, videoArea.nextSibling)
      }
    },
    pushMeetingEvents (meetinEventData) {
      const currentME = this.getMeetingEvents() || []
      currentME.push(meetinEventData)
      localStorage.setItem('meetingEvents', JSON.stringify(currentME))
    },
    initMeetingEvents () {
      localStorage.setItem('meetingEvents', JSON.stringify([]))
    },
    sendMeetingEventLogs (meetingEvent) {
      if (meetingEvent) {
        ChimeLogModel.apiSetStore(this.$bvModal, [meetingEvent], () => {}).catch((err) => {
          console.log(err)
          this.pushMeetingEvents(meetingEvent)
        })
      } else {
        const meetingEvents = this.getMeetingEvents() || []
        if (meetingEvents.length > 0) {
          ChimeLogModel.apiSetStore(this.$bvModal, meetingEvents, () => {}).then(() => {
            this.initMeetingEvents()
          })
        }
      }
    },
    getMeetingEvents () {
      const raw = localStorage.getItem('meetingEvents')
      return raw ? JSON.parse(raw) : []
    },
    // #83 2022/09/22 start 通話終了時の確認モーダル追加
    confirmFinishMeeting () {
      this.$refs.commonModal.msgBoxConfirm('ミーティングから退出します。よろしいでしょうか。')
    }
    // #83 2022/09/22 end
  },
  created: function () {
    this.logger = new ConsoleLogger('ChimeMeetingLogs', LogLevel.ERROR)
    this.deviceController = new DefaultDeviceController(this.logger)

    this.loginStatus = JSON.parse(localStorage.getItem('loginStatus') || '{}')
    if (this.config.isAwsChime && this.loginStatus?.prodInst !== '1') {
      this.start()
    }
  },
  mounted () {
    // mstoreに自videoエレメントがあれば表示
    if (mstore.getters.myselfVideo !== null && sessionStorage.hideMySelfVideo === 'false') {
      let myselfVideo = document.getElementById('myself')
      myselfVideo.classList.remove('user-video-hide')
      myselfVideo.append(mstore.getters.myselfVideo)
    }

    // mstoreに相手videoエレメントがあれば表示
    if (mstore.getters.yourselfVideo !== null && sessionStorage.hideYourSelfVideo === 'false') {
      let yourselfVideo = document.getElementById('yourself')
      yourselfVideo.classList.remove('user-video-hide')
      yourselfVideo.append(mstore.getters.yourselfVideo)
    }

    // mstoreにゲスト1videoエレメントがあれば表示
    if (mstore.getters.guest1selfVideo !== null && sessionStorage.hideGuest1SelfVideo === 'false') {
      let guest1selfVideo = document.getElementById('guest1')
      guest1selfVideo.classList.remove('user-video-hide-guest')
      guest1selfVideo.classList.add('user-video-guest')
      guest1selfVideo.append(mstore.getters.guest1selfVideo)
    }

    // mstoreにゲスト2videoエレメントがあれば表示
    if (mstore.getters.guest2selfVideo !== null && sessionStorage.hideGuest2SelfVideo === 'false') {
      let guest2selfVideo = document.getElementById('guest2')
      guest2selfVideo.classList.remove('user-video-hide-guest')
      guest2selfVideo.classList.add('user-video-guest')
      guest2selfVideo.append(mstore.getters.guest2selfVideo)
    }

    // mstoreにゲスト3videoエレメントがあれば表示
    if (mstore.getters.guest3selfVideo !== null && sessionStorage.hideGuest3SelfVideo === 'false') {
      let guest3selfVideo = document.getElementById('guest3')
      guest3selfVideo.classList.remove('user-video-hide-guest')
      guest3selfVideo.classList.add('user-video-guest')
      guest3selfVideo.append(mstore.getters.guest3selfVideo)
    }

    if (mstore.getters.meetingSession !== null && isOnlineMeeting()) {
      let meetingSession = mstore.getters.meetingSession
      meetingSession.audioVideo.bindAudioElement(this.$refs.meetingAudio)
      // 音出力設定
      meetingSession.audioVideo.start()

      // 非表示判定
      const tiles = meetingSession.audioVideo.getAllVideoTiles()
      tiles.forEach(tile => {
        if (!tile.tileState.isContent && tile.tileState.localTile) {
          if (!tile.tileState.active) {
            if (sessionStorage.customerType === this.consts.customerType.guest) {
              document.getElementById('guest1').classList.add('user-video-hide-guest')
            } else {
              document.getElementById('myself').classList.add('user-video-hide')
            }
          }
        } else if (!tile.tileState.isContent) {
          let myselfTileId = Number(sessionStorage.getItem('myselfTileId'))
          let yourselfTileId = Number(sessionStorage.getItem('yourselfTileId'))
          let guest1selfTileId = Number(sessionStorage.getItem('guest1TileId'))
          let guest2selfTileId = Number(sessionStorage.getItem('guest2TileId'))
          let guest3selfTileId = Number(sessionStorage.getItem('guest3TileId'))

          if (tile.tileState.tileId === myselfTileId && !tile.tileState.active) {
            document.getElementById('myself').classList.add('user-video-hide')
          }
          if (tile.tileState.tileId === yourselfTileId && !tile.tileState.active) {
            document.getElementById('yourself').classList.add('user-video-hide')
          }
          if (tile.tileState.tileId === guest1selfTileId && !tile.tileState.active) {
            document.getElementById('guest1').classList.add('user-video-hide-guest')
          }
          if (tile.tileState.tileId === guest2selfTileId && !tile.tileState.active) {
            document.getElementById('guest2').classList.add('user-video-hide-guest')
          }
          if (tile.tileState.tileId === guest3selfTileId && !tile.tileState.active) {
            document.getElementById('guest3').classList.add('user-video-hide-guest')
          }
        }
      })
    }
    // スピーカー音量設定
    if (isOnlineMeeting()) {
      this.$refs.meetingAudio.volume = mstore.getters.speakerVolume
      this.$refs.volumeRenge.value = mstore.getters.speakerVolume * 100
    } else {
      this.$refs.meetingAudio.volume = 0
      if (this.$refs.volumeRenge !== undefined) {
        this.$refs.volumeRenge.value = 0
      }
    }

    // ボリューム以外をクリック時にボリュームを非表示にする（解除できるようにする）
    this.onDocClick = (e) => {
      if (!e.target.closest('.volume-range') && !e.target.closest('#volume-button')) {
        this.isVolumeRange = false
      }
    }
    document.addEventListener('click', this.onDocClick)

    window.addEventListener('resize', this.calculateWindowWidth)
    this.calculateWindowWidth()
    // 商品詳細画面とスタイル提案画面以外はビデオ領域をスクロールに追従させる
    if (document.getElementById('meeting-camera-setting')) {
      if (this.type === this.consts.meetingType.florist || this.type === this.consts.meetingType.floristStyleImageProposal) {
        if (!this.$route.path.startsWith('/florist/meeting/product_selection') && this.$route.path !== '/florist/meeting/style_image_proposal') {
          document.getElementById('meeting-camera-setting').style.top = '65px'
          document.getElementById('meeting-camera-setting').style.position = 'sticky'
        }
      }

      if (this.type === this.consts.meetingType.customer || this.type === this.consts.meetingType.customerStyleImageProposal) {
        if (!this.$route.path.startsWith('/customer/meeting/product_selection') && this.$route.path !== '/customer/meeting/style_image_proposal') {
          document.getElementById('meeting-camera-setting').style.top = '5px'
          document.getElementById('meeting-camera-setting').style.position = 'sticky'
        }
      }
    }
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.calculateWindowWidth)
    // document click listener解除
    if (this.onDocClick) document.removeEventListener('click', this.onDocClick)

    // 画面遷移時などにMeetingSessionのログをCloudWatchに送信
    setTimeout(this.sendMeetingEventLogs.bind(this, null), 0)
  }
}
</script>
